import {Image} from 'exsportia-components'
import {useQuery} from 'react-query'

import {InstructorService} from '../../../api/instructors'
import {InstructorCard} from '../../../components/instructor-card/instructor-card'
import {LabeledSection} from '../../../ui/components/labeled-section/labeled-section'
import {useLocale} from '../../../utils/i18n'

export const InstructorSection = ({teacherId}: {teacherId: string}) => {
  const {l} = useLocale()
  const {data: instructor, isLoading: isInstructorLoading} = useQuery(
    InstructorService.getInstructorQuery({params: {id: teacherId}}),
  )
  return (
    <LabeledSection label={l('instructors')}>
      <InstructorCard
        name={instructor?.name || ''}
        isLoading={isInstructorLoading}
        image={<Image width='48px' height='48px' size='contain' src={instructor?.profileImage?.secure_url || ''} />}
      />
    </LabeledSection>
  )
}
